<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<!-- <a-button class="qinang-button-margin" icon="sync" @click="apiOrderdetailsQueryAll">刷新</a-button> -->
				<a-button icon="rollback" @click="routerBack">返回</a-button>
			</div>
		</div>
		
		<div class="qinang-card-2">
			<div class="qa-card-title">
				订单信息
			</div>
			<a-descriptions  size="small">
				<a-descriptions-item label="订单编号">{{orderInfo.ordersNumber}}</a-descriptions-item>
				<a-descriptions-item label="类型">
					<span v-if="orderInfo.ordersType == 2">售票</span>
					<span v-if="orderInfo.ordersType == 3">退票</span>
					<span v-if="orderInfo.ordersType == 4">补录</span>
				</a-descriptions-item>
				<a-descriptions-item label="服务商">{{orderInfo.facilitatorName}}</a-descriptions-item>
				<a-descriptions-item label="售票站点">{{orderInfo.ticketstationName}}</a-descriptions-item>
				<a-descriptions-item label="售票窗口">{{orderInfo.ticketwindowName}}</a-descriptions-item>
				<a-descriptions-item label="售票员">{{orderInfo.staffName}}</a-descriptions-item>
				<a-descriptions-item label="订单数量">{{orderInfo.ordersQuantity}}</a-descriptions-item>
				<a-descriptions-item label="订单总价">{{orderInfo.ordersTotal / 100}}</a-descriptions-item>
				<a-descriptions-item label="下单时间">{{moment(orderInfo.createTime).format('YYYY-MM-DD HH:mm:ss')}}</a-descriptions-item>
			</a-descriptions>
		</div>

		
		<div class="qinang-card">
			<div class="qa-card-title">
				票号信息
			</div>
			<a-table :columns="tableColumns" :data-source="tableData" row-key="orderdetailsId"
				:loading="tableLoading" :pagination="false">
				<span slot="ordersType" slot-scope="ordersType">
					<span v-if="ordersType.ordersType == 2">售票</span>
					<span v-if="ordersType.ordersType == 3">退票</span>
					<span v-if="ordersType.ordersType == 4">补录</span>
				</span>
				<span slot="totalPrice" slot-scope="totalPrice">
					{{totalPrice.totalPrice / 100}}
				</span>
				<span slot="ordersQuantity" slot-scope="ordersQuantity">
					{{ordersQuantity.quantity}}<a-divider type="vertical" />{{ordersQuantity.checkedQuantity}}<a-divider type="vertical" />{{ordersQuantity.refundQuantity}}
				</span>
				<span slot="createTime" slot-scope="createTime">
					{{qaUtil.timeFormat(createTime.createTime)}}
				</span>
				
			</a-table>
		</div>


		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				orderInfo: JSON.parse(window.sessionStorage.getItem('ticktingFlowsSelectOrder')),
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0
				},
	
				tableData: [],
				tableColumns: [
					{
						title: '票号',
						dataIndex: 'ticketNumber',
						key: 'ticketNumber',
						align: 'center'
					},
					{
						title: '产品名称',
						dataIndex: 'productName',
						key: 'productName',
						align: 'center'
					},
					{
						title: '人群种类',
						dataIndex: 'crowdtypeName',
						key: 'crowdtypeName',
						align: 'center',
					},
					{
						title: '业务类型',
						dataIndex: 'businesstypeName',
						key: 'businesstypeName',
						align: 'center',
					},
					{
						title: '数量',
						dataIndex: 'quantity',
						key: 'quantity',
						align: 'center',
					},
					{
						title: '金额',
						key: 'totalPrice',
						align: 'center',
						scopedSlots: {
							customRender: 'totalPrice'
						}
					},
					{
						title: '总数|检票数|退票数',
						key: 'ordersQuantity',
						align: 'center',
						scopedSlots: {
							customRender: 'ordersQuantity'
						}
					},
					{
						title: '下单时间',
						key: 'createTime',
						align: 'center',
						scopedSlots: {
							customRender: 'createTime'
						}
					}

				],
				tableLoading: false,
				//搜索+表格-end
		
			};
		},
		methods: {
			async apiOrderdetailsQueryAll() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiOrderdetailsQueryAll, {ordersNumber: this.orderInfo.ordersNumber});
				if (res.code == 200) {
					this.tableData = res.data
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			routerBack() {
				this.$router.push('/TicktingFlow')
			}
			
		},
		computed: {
			
		},
		created() {
			this.apiOrderdetailsQueryAll()
		}
	};
</script>

<style scoped>
	

</style>
